// src/pages/Order/Purchase Order/Purchase Order Entry/purchaseOrderThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getPredictionAPI,
  getPurchaseOrderInvoiceApi,
} from "../../../../apiservice/purchase";
import { postData } from "../../../../apiservice/apis";
import { createPurchaseOrderPayload } from "../../../../utils/purchaseOrder";
import { getAccountByTypeApi } from "../../../../apiservice/setting";

// Fetch order number
export const fetchPurchaseOrderNumber = createAsyncThunk(
  "purchaseOrder/fetchPurchaseOrderNumber",
  async (val) => {
    const res = await getPurchaseOrderInvoiceApi({ entryDate: val });
    return res.data;
  }
);

// Create or Update Purchase Order
export const createPurchaseOrder = createAsyncThunk(
  "purchaseOrder/createPurchaseOrder",
  async (_, { getState, rejectWithValue }) => {
    try {
      const state = getState().purchaseOrder;


      const { auth_info: authInfo } = getState().auth;
      const payload = createPurchaseOrderPayload(state, authInfo);   
     
      let res;
      if (state.pur_o_id) {
        res = await postData(`/purchase/update-purchase-order`, {
          ...payload,
          pur_o_id: state.pur_o_id,
        });
      } else {
        res = await postData(`/purchase/create-purchase-order`, payload);
      }

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchTransportAccounts = createAsyncThunk(
  "purchaseOrder/fetchTransportAccounts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountByTypeApi({
        acc_type_id: "direct_expense",
      });
      return res.data[0];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const fetchPrediction = createAsyncThunk(
  "purchaseOrder/fetchPrediction",
  async (item_id, { rejectWithValue }) => {
    try {
      const res = await getPredictionAPI({
        item_id,
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
